import React from 'react';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_ACCENT_LOGO,
  COLOR_BACKGROUND_LIGHT,
  COLOR_BACKGROUND_PRIMARY,
  COLOR_BORDER_DEFAULT,
  COLOR_OVERLAY_BACKDROP_STRONG,
  COLOR_TEXT_INVERSE,
  COLOR_TEXT_PRIMARY,
  COLOR_TEXT_QUATERNARY,
  COLOR_TEXT_TERTIARY,
} from '../colors/colors';

const OverlayBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${COLOR_OVERLAY_BACKDROP_STRONG};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;
`;

const OverlayContainer = styled.div`
  background: ${COLOR_BACKGROUND_PRIMARY};
  border-radius: ${RADIUS.MD} ${RADIUS.MD} 0 0;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${COLOR_BORDER_DEFAULT};
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  color: ${COLOR_TEXT_PRIMARY};
`;

const LogoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: ${COLOR_ACCENT_LOGO};
  border-radius: ${RADIUS.CIRCLE};
  color: ${COLOR_TEXT_INVERSE};
  font-size: 14px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: ${RADIUS.CIRCLE};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLOR_TEXT_TERTIARY};
  font-size: 18px;

  &:hover {
    background: ${COLOR_BACKGROUND_LIGHT};
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
`;

const Footer = styled.div`
  padding: 12px 20px;
  text-align: center;
  border-top: 1px solid ${COLOR_BORDER_DEFAULT};
`;

const FooterLogo = styled.span`
  font-size: 12px;
  color: ${COLOR_TEXT_QUATERNARY};
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const YouOverlay = ({ children, onClose, showFooter = true }) => {
  return (
    <OverlayBackdrop>
      <OverlayContainer>
        <Header>
          <Logo>
            <LogoIcon>✓</LogoIcon>
            you
          </Logo>
          {onClose && (
            <CloseButton onClick={onClose} aria-label="Fechar">
              ✕
            </CloseButton>
          )}
        </Header>
        <Content>{children}</Content>
        {showFooter && (
          <Footer>
            <FooterLogo>Unico</FooterLogo>
          </Footer>
        )}
      </OverlayContainer>
    </OverlayBackdrop>
  );
};
